import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Box, Text, Container } from '@radix-ui/themes';

import Card from '../../../shared/Card';
import LoadingComponent from '../../../shared/LoadingComponent';
import { VaultTable } from './VaultTable.jsx';
import { useGetVaultFiles } from '../data';
import useSort from '../../../shared/Sort/useSort';

export const VaultListView = ({
  organizationData,
  uploadingFiles,
  categories,
  vendors,
}) => {
  const { t } = useTranslation('vault');
  const [showAll, setShowAll] = useState(false);
  const [page, setPage] = useState(1);
  const { sortingStatus, changeSort } = useSort({ persistInUrl: true });

  const itemsPerPage = 10;
  const onPageChange = data => setPage(data.selected + 1);
  const { isLoading, data = { vaultFiles: [], pagy: {} } } = useGetVaultFiles({
    page,
    itemsPerPage,
    showAll,
    ...sortingStatus,
  });

  const { pagy, vaultFiles } = data;
  const showPagination = vaultFiles.length || uploadingFiles.length;

  if (isLoading) return <LoadingComponent />;

  return (
    <Card
      title={t('files', { organizationName: organizationData.name })}
      items={showPagination && !showAll ? itemsPerPage : undefined}
      pagy={showPagination && !showAll ? pagy : undefined}
      onPageChange={showPagination && !showAll ? onPageChange : undefined}
      onClick={() => setShowAll(!showAll)}
      canShowAll={showPagination}
      isShowingAll={showAll}
      margin="0"
    >
      <Box p="0 16px">
        {vaultFiles.length || uploadingFiles.length ? (
          <VaultTable
            vaultFiles={vaultFiles}
            uploadingFiles={uploadingFiles}
            categories={categories}
            vendors={vendors}
            sortingStatus={sortingStatus}
            changeSort={changeSort}
          />
        ) : (
          <Container size="2" p="6" mx="auto" style={{ maxWidth: '500px' }}>
            <Flex direction="column" align="center" gap="4">
              <Text size="3" weight="bold">
                {t('welcomeHeader')}
              </Text>
              <Text
                size="3"
                align="center"
                color="gray"
                style={{ whiteSpace: 'pre-line' }}
              >
                {t('welcomeMessage')}
              </Text>
            </Flex>
          </Container>
        )}
      </Box>
    </Card>
  );
};
